import React, { Component } from 'react';
import {connect} from 'react-redux';
import { fetchAlldemoCategories, deleteCategory} from '../../actions/demographics';
import DemographicsCategoriesList from '../../components/demographics';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.css';

class DemographicsCategories extends Component {
  constructor(props){
    super(props)
    this.state={

    };
    this.showCategoryAddDemographics = this.showCategoryAddDemographics.bind(this);
    this.softDeleteCategory = this.softDeleteCategory.bind(this);
    
  }

  
  componentWillMount() {
    let token=sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchAlldemoCategories(token));
  }

  showCategoryAddDemographics(){
      this.props.history.push('/addDemographicsCategories');
  }

  

  softDeleteCategory(data){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
             <div className = "alertimg"> <img src={require("../image/alert.png")}  className = "panellogo"/></div>
             <div className = "alert">Are you sure?</div>
             <p className = "alertmsg">You want to delete this file?</p>
            <button className = "alertbtn" onClick={onClose}>No</button>
            <button className = "alertbutton" onClick={() => {
               this.props.dispatch(deleteCategory(data))
                onClose()
            }}>Yes, Delete it!</button>
          </div>
        )
      }
    })
  }

 

  render(){
    let showDemographicsCategoriesView = <DemographicsCategoriesList
        demoGraphicsCategoriesListSuccess = {this.props.demoGraphicsCategoriesListSuccess}
        demoGraphicsCategoriesList = {this.props.demoGraphicsCategoriesList}
        showCategoryAddDemographics = { this.showCategoryAddDemographics}
        softDeleteCategory = {this.softDeleteCategory}
       
    />
      
    return (
        <div> 
             {showDemographicsCategoriesView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsCategoriesListSuccess : state.demographics.demoGraphicsCategoriesListSuccess,
    demoGraphicsCategoriesList : state.demographics.demoGraphicsCategoriesList
  }
}

export default connect(mapStateToProps)(DemographicsCategories);



// WEBPACK FOOTER //
// ./src/pages/demographics/index.js